export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('@/modules/auth/views/LoginView.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/cadastro2fa',
        name: 'autenticacao',
        component: () => import('@/modules/pessoas/views/cadastros/AutenticacaoView.vue'),
        meta: { requiresAuth: true },
    },
    {
        path: '/autocadastro',
        name: 'autoCadastroPessoaFisica',
        component: () => import('@/modules/pessoas/views/cadastros/AutoCadastroPessoaFisicaView.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/documento/verificacaoassinatura',
        name: 'validarAssinatura',
        component: () => import('@/modules/pessoas/views/detalhes/ValidarAssinaturaView.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/resetsenha',
        name: 'resetSenha',
        component: () => import('@/modules/auth/views/ResetSenhaView.vue'),
        meta: { requiresAuth: false },
    },
    {
        path: '/esquecisenha',
        name: 'esqueciSenha',
        component: () => import('@/modules/auth/views/EsqueciSenhaView.vue'),
        meta: { requiresAuth: false },
    },
]
